export class HttpError extends Error {
    constructor(message, status) {
        super(message); // 'Error' breaks prototype chain here
        this.name = 'HttpError';
        this.status = status;
        Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
    }
}
//# sourceMappingURL=model.http-error.js.map